import * as React from 'react';

/**
 * @description CardMinus icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CardMinus } from '@sravni/design-system-icons'
 *
 * <CardMinus />
 * ```
 */
const CardMinus = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "CardMinus", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M11.131 14.88H3.724c-1.116 0-2.02-.877-2.02-1.957V6.4c0-1.08.904-1.957 2.02-1.957h10.774c1.116 0 2.02.876 2.02 1.957v3.26M1.111 7.343h15.144", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M4.667 11.98h3.555", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round" }),
    React.createElement("path", { d: "M14.74 17.778c2.292 0 4.149-1.817 4.149-4.058 0-2.241-1.857-4.058-4.148-4.058-2.291 0-4.149 1.817-4.149 4.058 0 2.241 1.858 4.058 4.149 4.058Z", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M16.222 13.72h-1.481M13.26 13.72h1.48", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { CardMinus };
//# sourceMappingURL=CardMinus.js.map
